import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from "@eb/i18n";

import { AlertChunky } from '@eb/eds-iconography';

import { Button } from '@eb/eds-button';

import PageHeader from '../PageHeader';

import PrivacyTerms from '../../connectedComponents/PrivacyTerms';

const ToSForm = ({ dataTestId, onCancelToS, onAcceptToS }) => (
    <div
        className="tos-form eds-fx--fade-in eds-fx--delay-2"
        data-testid={dataTestId}
    >
        <PageHeader
            headerText={gettext('Terms and conditions')}
            iconType={<AlertChunky />}
            subtitleText={<PrivacyTerms />}
            iconColor="ui-700"
            bottomSpacing="eds-l-mar-bot-6"
            headerClassName="eds-text-hs eds-l-mar-bot-5"
        />

        <div className="tos-form__actions eds-l-pad-bot-8 eds-align--center">
            <Button
                onClick={onCancelToS}
                type="button"
                __containerClassName="eds-l-mar-right-8"
                data-testid={`${dataTestId}-button-cancel`}
            >
                {gettext('Cancel')}
            </Button>
            <Button
                onClick={onAcceptToS}
                type="button"
                style="fill"
                __containerClassName="eds-l-mar-right-8"
                data-testid={`${dataTestId}-button-accept`}
            >
                {gettext('Agree')}
            </Button>
        </div>
    </div>
);

ToSForm.propTypes = {
    dataTestid: PropTypes.string,
    onCancelToS: PropTypes.func,
    onAcceptToS: PropTypes.func,
};

export default ToSForm;
